<template>
  <div class="position-relative mt-3" id="noclaimsdiscountTable">
    <div class="actions text-right" id="noclaimsdiscountTable-showAddEditDialog">
      <button class="btn btn-primary icon-button" @click="showAddEditDialog = true"
        id="noclaimsdiscountTable-add-Button">
        <span class="btn-icon" id="noclaimsdiscountTable-addButton-span">
          <i class="fa fa-plus" aria-hidden="true" id="noclaimsdiscountTable-addButton-data"></i>
        </span>
        {{ 'ADD' | translate }}
      </button>
    </div>

    <vodal :show="showAddEditDialog" :width="400" :closeOnEsc="true" :closeOnClickMask="false"
      :customStyles="{ 'top': '80px', 'bottom': 'auto', 'height': 'auto' }" animation="rotate" @hide="closeDialog">
      <no-claims-discount-add-edit-dialogue
        ref="addEditDialogue"
        :edited="editedRow"
        @save="onSaveNew"
        @update="onUpdate"
        @close="closeDialog"
        :errortype="error"
        id="noclaimsdiscountTable-addEditDialog">
      </no-claims-discount-add-edit-dialogue>
    </vodal>
    
    <table class="table table-striped table-hover" id="noclaimsdiscountTable-tableData">
      <caption></caption>
      <tr>
        <th>{{ 'No_Claims_Discount_DESCRIPTION' | translate }}</th>
        <th>{{ 'Step' | translate }}</th>
        <th>{{ 'DiscountPercentage' | translate }}</th>
      </tr>
      <tr v-for="row in rows" :key="row.code">
        <td>{{ row.description }}</td>
        <td>
          <div v-for="(myentry, index) in row.entries" :key="index" class="apiValueIncoming-item">
            {{ myentry.step }}
          </div>
        </td>
        <td>
          <div v-for="(myentry, index) in row.entries" :key="index" class="apiValueIncoming-item">
            {{ myentry.discountPercentage | discountFormat }}
          </div>
        </td>
        <td id="noclaimsdiscountTable-tableButtons">
          <button class="btn btn-success icon-button icon-button-collapsed"
            v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)"
            :id="'noclaimsdiscountTable-tableEditButton-' + row.description">
            <span class="btn-icon" :id="'noclaimsdiscountTable-tableEditSpan-' + row.description">
              <i class="fa fa-pencil" aria-hidden="true"
                :id="'noclaimsdiscountTable-tableEditData-' + row.description"></i>
            </span>
          </button>
          <button class="btn btn-danger icon-button icon-button-collapsed"
            v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)"
            :id="'noclaimsdiscountTable-tableDeleteButton' + row.description">
            <span class="btn-icon" :id="'noclaimsdiscountTable-tableDeleteSpan-' + row.description">
              <i class="fa fa-trash-o" aria-hidden="true"
                :id="'noclaimsdiscountTable-tableDeleteData-' + row.description"></i>
            </span>
          </button>
        </td>
      </tr>
    </table>
    <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
      @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.code)">
    </confirm-dialog>
  </div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import NoClaimsDiscountAddEditDialogue from './NoClaimsDiscountAddEditDialogue.vue';
import Vodal from 'vodal';
import ConfirmDialog from '../../dialog/ConfirmDialog.vue';
import KeycloakService from '../../../service/keycloak/KeycloakService';

export default {
  components: { NoClaimsDiscountAddEditDialogue, Vodal, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      filter: '',
      rows: [],
      editedRow: null,
      showAddEditDialog: false,
      showDeleteConfirmDialog: false,
      selectedRow: null,
      error: null
    }
  },
  beforeMount() {
    this.loadRows();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadRows() {
      const noclaimsdiscountResponse = await this.rest.getAllNoclaimsdiscountRows();
      this.rows = noclaimsdiscountResponse.data;
    },
    async onSaveNew(row) {
      try {
        await this.rest.createNoclaimsdiscountRow(row);
        this.closeDialog();
        this.loadRows();
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.setError('ERROR_DUPLICATE_RECORD_STEP');
        } else {
          this.setError('ERROR_DURING_OPERATION');
        }
        this.$log.error(error.response ? error.response.data : error);
      }
    },
    async onUpdate(row) {
      try {
        await this.rest.updateNoclaimsdiscountRow(row);
        this.closeDialog();
        this.loadRows();
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.setError('ERROR_DUPLICATE_RECORD_STEP');
        } else {
          this.setError('ERROR_DURING_OPERATION');
        }
        this.$log.error(error.response ? error.response.data : error);
      }
    },
    onEdit(row) {
      this.editedRow = { ...row };
      this.showAddEditDialog = true;
    },
    onRemove(rowId) {
      this.rows = this.rows.filter(row => row.code !== rowId);
      this.rest.deleteNoclaimsdiscountRow(rowId);
      this.showDeleteConfirmDialog = false;
    },
    closeDialog() {
      this.showAddEditDialog = false;
      this.editedRow = false;
      if (this.$refs.addEditDialogue) {
        this.$refs.addEditDialogue.resetNoClaimsDiscount();
      }
      this.loadRows();
    },
    confirmDelete(row) {
      this.selectedRow = row;
      this.showDeleteConfirmDialog = true;
    },
    setError(errorMessage) {
      this.error = errorMessage;
      setTimeout(() => {
        this.error = false;
      }, 5000);
    }
  },
  filters: {
    discountFormat(value) {
      const lang = KeycloakService.getLanguage();
      let formattedValue = value;
      if (typeof value === 'number') {
        formattedValue = value.toFixed(2);
      }
      if (lang === 'nl' && typeof formattedValue === 'string') {
        return formattedValue.replace('.', ',');
      }
      return formattedValue;
    }
  }
}
</script>

<style lang="scss" scoped>
>>>.vue-table {
  border: 0;

  th,
  td {
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
  }

  thead > tr > th {
    padding-right: .75rem;
    padding-left: 30px !important;
  }

  .arrow:before {
    bottom: 12px;
    right: auto;
    left: 12px;
    font-family: 'FontAwesome', sans-serif;
  }

  .icon-button {
    opacity: 0;
    transition: opacity .1s ease-out;
  }

  tr:hover .icon-button {
    opacity: 1;
  }
}

.actions {
  position: absolute;
  z-index: 1;
  top: 10px;
  right: 0;

  .icon-button {
    padding-right: 15px;
    padding-left: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/NoClaimsDiscount/NoClaimsDiscountTable.vue